import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
/* Reset CSS */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  font-size: 100%;
  font-family: sans-serif;
  /* Fuente predeterminada si no se carga la fuente personalizada */
  background-color: ${({ theme }) => theme.fill.defaultMain};
}

p,h1,h2,h3,h4,h5,h6 {
margin: 0
}

a {
  text-decoration: none;
  color: inherit;
}

ol,
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

@font-face {
  font-family: 'MonaSans';
  src: url('/fonts/MonaSansVF-Regular.woff2') format('woff2');
  font-weight: 100 900;
  font-style: normal;
  font-display: swap; /* Permite mostrar texto inmediatamente con fuente fallback */
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: 'ss01' on, 'ss05' on, 'ss06' on, 'ss07' on;
  /* Asegurar que la fuente se cargue desde el cache del navegador */
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

body {
  font-family: 'MonaSans', sans-serif;
  font-feature-settings: 'ss01' on, 'ss05' on, 'ss06' on, 'ss07' on;
  font-variant-numeric: lining-nums tabular-nums;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.pac-item {
  border: 0px;
  padding: 4px 8px;
  border-radius: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.fill.defaultWeak};
  }

  span {
    font-family: 'MonaSans', sans-serif;
    line-height: 32px;
    font-weight: 500;
  }
  
  .pac-icon {
    background-image: url(${process.env.REACT_APP_CLIENT_URL}/icons/location.svg);
    background-size: 16px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .pac-matched {
    font-weight: 600;
  }
}

.pac-container {
  border: 0px;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border-radius: 8px;
  padding: 8px;
  z-index: 9999 !important;
}

/* Estilos personalizados para react-toastify */
.Toastify__toast-container {
  font-family: 'MonaSans', sans-serif;
  max-width: 320px;
  width: 100%;
  
  /* Centrado en móviles */
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    left: 50% !important;
    transform: translateX(-50%) !important;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.sizing.sm};
    box-sizing: border-box;
  }
}

.Toastify__toast {
  background-color: ${({ theme }) => theme.fill.inverseMain};
  color: ${({ theme }) => theme.colors.inverseMain};
  border-radius: 19px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: 'MonaSans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  min-height: 24px;
  margin-bottom: ${({ theme }) => theme.sizing.xxs};
}

.Toastify__toast--success {
}

.Toastify__toast--error {
}

.Toastify__toast--warning {
}

.Toastify__toast--info {
}

.Toastify__toast-icon {
  margin-right: 0px;
}

/* .Toastify__progress-bar {
  display: none !important;
} */

.Toastify__progress-bar--success {
  background: ${({ theme }) => theme.colors.successMain};
}

.Toastify__progress-bar--error {
  background: ${({ theme }) => theme.colors.errorMain};
}

.Toastify__progress-bar--warning {
  background: ${({ theme }) => theme.colors.warningMain};
}

.Toastify__close-button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
  margin-top: 2px;
  margin-left: 2px;

  svg {
    fill: ${({ theme }) => theme.colors.inverseStrong} !important;
  }
}

.Toastify__close-button:hover {
  opacity: 1;
  svg {
    fill: ${({ theme }) => theme.colors.inverseMain} !important;
  }}

.Toastify__toast-body {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.xs};
  height: fit-content;
  // width: fit-content;
}
`;

export default GlobalStyle;